import { Controller } from "@hotwired/stimulus"

// Forwards the browser to urlValue after delayValue ms — used by the
// onboarding handoff page so the conversion tag has time to fire.
export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 2000 } }

  connect() {
    this.timer = setTimeout(() => window.location.assign(this.urlValue), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
